import React, { memo } from "react";
import PropTypes from "prop-types";
import Divider from "../../Common/Divider";
const Page = memo(({ page, isSelectedPage, selectPage }) => {
	const pageNumber = page + 1;
	return (
		<button
			onClick={() => {
				selectPage(page);
			}}
			className={`page-selector-button ${isSelectedPage && `active`}`}
		>
			{isSelectedPage ? <strong>{pageNumber}</strong> : pageNumber}
		</button>
	);
});

const PageSelector = memo(({ page, lengthOfArray, stepLength, selectPage }) => {
	const pages = [];
	const numberOfPages = Math.ceil(lengthOfArray / stepLength);
	if (numberOfPages < 2) {
		return null;
	}

	for (let i = 0; i < numberOfPages; i++) {
		pages.push(<Page key={i} isSelectedPage={i === page} page={i} selectPage={selectPage} />);
	}

	return (
		<>
			<div className="row">
				<div className="col-xs-12">
					<div className="pull-right">{pages}</div>
				</div>
			</div>
			<Divider />
		</>
	);
});

Page.displayName = `Page`;
Page.propTypes = {
	page: PropTypes.number,
	isSelectedPage: PropTypes.bool,
	selectPage: PropTypes.func
};
PageSelector.displayName = `PageSelector`;
PageSelector.propTypes = {
	page: PropTypes.number,
	lengthOfArray: PropTypes.number,
	stepLength: PropTypes.number,
	selectPage: PropTypes.func
};

export default PageSelector;
